import React, { useMemo } from "react";
import { Grid, Box, Typography } from "@material-ui/core";
import { useQuery } from "@apollo/client";
import queries from "Shared/queries";
import useStyles from "./styles";
import { MetricBox } from "./MetricBox/MetricBox";
import overviewSectionMetricBoxes from "./overviewSectionMetricBoxes";
import {
  GetProviderMetricsQuery,
  GetProviderMetricsQueryVariables,
} from "generated/graphql";

const defaultData = {
  active: 0,
  champions: 0,
  eligible: 1,
  transferredLast7DaysCents: 0,
  withRecentInvoices: 0,
};

const OverviewSection = () => {
  const { data, loading, error } = useQuery<
    GetProviderMetricsQuery,
    GetProviderMetricsQueryVariables
  >(queries.GET_PROVIDER_METRICS);

  const metricsData = data
    ? data.employer.currentProvider.metrics
    : defaultData;

  const informedMetricsBoxes = useMemo(
    () =>
      overviewSectionMetricBoxes.map(({ getValue, ...metricBox }) => ({
        ...metricBox,
        value: getValue(metricsData),
      })),
    [metricsData]
  );

  const classes = useStyles();

  return (
    <Grid container spacing={2} alignContent={"stretch"}>
      <Grid item>
        <Box pt={3}>
          <Typography variant="h1">Overview</Typography>
        </Box>
      </Grid>
      <Grid
        item
        container
        direction={"row"}
        spacing={2}
        className={classes.overviewPanelsGrid}
        justify="space-between"
      >
        {informedMetricsBoxes.map((metricBox) => (
          <MetricBox {...metricBox} key={metricBox.title} loading={loading} />
        ))}
      </Grid>
    </Grid>
  );
};

export default OverviewSection;
